export interface AdjustmentIndicator {
  percent: number;
  direction: 'reduction' | 'increase';
}

export function computeAdjustmentIndicator(
  quantity: number | null,
  unitPrice: number | null,
  adjustment: number | null,
): AdjustmentIndicator | null {
  const value = typeof adjustment === 'number' && Number.isFinite(adjustment) ? adjustment : 0;
  if (value === 0) {
    return null;
  }
  const base =
    typeof quantity === 'number' &&
    Number.isFinite(quantity) &&
    typeof unitPrice === 'number' &&
    Number.isFinite(unitPrice)
      ? quantity * unitPrice
      : null;
  if (!base || base === 0) {
    return null;
  }
  return {
    percent: Math.abs(Math.round((value / base) * 100)),
    direction: value < 0 ? 'reduction' : 'increase',
  };
}
